import { useEffect } from "react";
import { Link } from "react-router-dom";

export const ROOMS = [
  { to: "/parametric", slug: "climate-insurance", label: "Climate Insurance", words: ["Climate", "Insurance"] },
  { to: "/origin-risk", slug: "classification-standard", label: "Classification Standard", words: ["Classification", "Standard"] },
  { to: "/intelligence", slug: "macro-opportunity", label: "Macro Opportunity", words: ["Macro", "Opportunity"] },
  { to: "/adaptation-intelligence", slug: "biological-limits", label: "Biological Limits", words: ["Biological", "Limits"] },
  { to: "/food-supply", slug: "food-supply", label: "Food Supply", words: ["Food", "Supply"] },
  { to: "/nature-asset", slug: "nature-asset", label: "Nature Asset", words: ["Nature", "Asset"] },
  { to: "/work-with", slug: "work-with", label: "Work / With", words: ["Work", "With"] },
];

export const CONTACT_ADDRESS = "intelligence@maattr.com";

export function RoomsNav() {
  return (
    <nav className="rooms" aria-label="Rooms" data-testid="rooms-nav">
      {ROOMS.map((r) => (
        <Link key={r.to} to={r.to} data-testid={`room-link-${r.to.slice(1)}`}>
          <span>{r.words[0]}</span>
          <span>{r.words[1]}</span>
        </Link>
      ))}
    </nav>
  );
}

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description || "");
  }, [title, description]);
}
